import AccountRecoveryMethodPage from './AccountRecoveryMethodPage';

export default AccountRecoveryMethodPage;


// WEBPACK FOOTER //
// ./src/components/pages/AccountRecoveryMethodPage/index.js